import React, { useState } from 'react';
import { connect } from 'react-redux';
import Breadcrumbs from '../../components/Common/Breadcrumb';
import PageDataLoader from '../Utility/PageDataLoader';
import { Container } from 'reactstrap';
import WeeklyActionRecord from './WeeklyActionRecord';

const BulkCreateWeeklyReport = ({ authUser }) => {

    const [breadcrumbItems] = useState([
        { title: 'Offerings', link: '#' },
        { title: 'Bulk Create Weekly Record', link: '#' }
    ]);

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid >
                    <Breadcrumbs
                        title="Bulk Create Weekly Record"
                        breadcrumbItems={breadcrumbItems}
                    />

                    <WeeklyActionRecord authUser={authUser} />
                </Container>
            </div>
        </React.Fragment>
    )

};

const mapStateToProps = (state) => {
    return {
        authUser: state.Login?.user
    };
};

export default connect(mapStateToProps)(BulkCreateWeeklyReport);